import {cleanEntity} from "@mytour/platform";
import type {
  CreatePennylaneAccountPayload,
  CreatePennylaneAccountResponse,
  EinvoicingStatusResponse,
  UpdateEinvoicingChoicePayload,
} from "@mytour/shared";
import axios from "axios";

export const einvoicingApiService = {
  async getStatus(): Promise<EinvoicingStatusResponse> {
    const result = await axios.get<EinvoicingStatusResponse>("api/einvoicing/");
    return result.data;
  },

  async updateChoice(payload: UpdateEinvoicingChoicePayload): Promise<EinvoicingStatusResponse> {
    const result = await axios.post<EinvoicingStatusResponse>("api/einvoicing/choice", payload);
    return result.data;
  },

  async createPennylaneAccount(
    payload: CreatePennylaneAccountPayload
  ): Promise<CreatePennylaneAccountResponse> {
    const result = await axios.post<CreatePennylaneAccountResponse>(
      "api/einvoicing/pennylane-account",
      cleanEntity(payload)
    );
    return result.data;
  },

  async markNudgeShown(): Promise<EinvoicingStatusResponse> {
    const result = await axios.post<EinvoicingStatusResponse>("api/einvoicing/nudge-seen");
    return result.data;
  },
};
